"use client"

import { memo } from "react";
import { PaperInformation as BasePaperInformation } from "./PaperInformation";

export const PaperInformationMemo = memo(BasePaperInformation, (prev, next) => {
  // 仅比较必要的 props。该组件接收的 props 仍是 paper 对象本身，
  // 为避免重渲染，建议后续将其替换为更细粒度的原始值。
  return (
    prev.subjectId === next.subjectId &&
    prev.className === next.className &&
    prev.paper.paperId === next.paper.paperId &&
    prev.paper.paperName === next.paper.paperName &&
    prev.paper.titleZh === next.paper.titleZh &&
    prev.paper.titleChinese === next.paper.titleChinese &&
    prev.paper.extra?.title === next.paper.extra?.title &&
    prev.paper.extractContent === next.paper.extractContent &&
    prev.paper.subjects === next.paper.subjects &&
    prev.isPinned === next.isPinned &&
    prev.isPinPending === next.isPinPending &&
    prev.pendingPinAction === next.pendingPinAction &&
    prev.isPinDisabled === next.isPinDisabled &&
    prev.pinLimit === next.pinLimit &&
    prev.onPinChange === next.onPinChange
  );
});
